export default {
    'Background Image': "Imagen de fondo",
    'Internal media storage is empty.': 'El almacenamiento interno de medios está vacío.',
    'Insert background image': 'Insertar imagen de fondo',
    'Remove background image': "Eliminar la imagen de fondo",
}